module.exports = __webpack_public_path__ + "media/images/shared/delivery/baikal-servis-92beb04535dcb4dda8ba6c66a312b0cb.png";